import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import api from "../../datasource/api";

export const getAllAudithLogin = createAsyncThunk(
  "hospitalAudit/getAllAudithLogin",
  async (
    data: {
      order: string;
      orderBy: string;
      searchQuery?: string;
      page: number;
      rowsPerPage: number;
      searchKeywords?: string;
      id?: string
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await api.get(
        `LoginStatus/logins/hospitalstatus?order=${data.order}&orderBy=${data.orderBy
        }${data.searchQuery ?? ""}&page=${data.page + 1}&pageSize=${data.rowsPerPage
        }&searchKeywords=${data?.searchKeywords}&id=${data?.id ?? ""}`
      );
      console.log(response.data, "datanewk")
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        if (error?.response?.status === 500) {
          window.location.href = "/error"; // or your routesName.errorPage
        }
      }
      return rejectWithValue(error);
    }
  }
);
